<template>
  <div id="buyList">
    <div class="thead">Покупка ROBUX</div>
    <div class="sub">Для покупки R$ необходимо создать gamepass, равный стоимости количества желаемых R$.</div>
	<div class="sub"><a href="https://www.youtube.com/watch?v=8iBuZ2B31oc" target="_blank">Видео инструкция по созданию gamepass</a></div>
    <div class="sub">
      Курс обмена:
      <span class="t-white">
        1 <span class="t-green">₽</span> - {{ $root.common.rate }}
        <span class="t-red">R$</span>
      </span>
    </div>
	<PriceCalculator @amount="a => amount = a" :preamount="amount" :rate="$root.common.rate" />
    <div class="sector bg-darker wa">
	  <div class="fs30 t-light">Введите ссылку на gamepass <a href="#" @click="findByName">найти по нику</a></div>
      <input type="text" class="bg-darker wa" placeholder="https://www.roblox.com/game-pass/109114798/apple" v-model="gamepass" />
    </div> 
	<div class="sector bg-darker wa">
	  <div class="fs30 t-light">Промокод (если есть)</div>
      <input type="text" class="bg-darker wa" v-model="promo" />
    </div>
    <pre class="sub wa">
Наша система автоматически купит ваш gamepass как можно скорее.
При покупке R$ будет использован платежный шлюз.
Пожалуйста ознакомьтесь с правилами использования сервиса.</pre>
    <PayWays @method="x => method = x"></PayWays>
	<button class="fs30" @click="buy">Оплатить</button>
  </div>
</template>

<script>
import PriceCalculator from "@/components/PriceCalculator";
import PayWays from "@/components/PayWays";
import Utils from "@/utils.js";

export default {
  props: ["data"],

  components: {
    PayWays,
    PriceCalculator,
  },

  data () {
	return {
    method: "nicepay",
	  amount: this.data ? this.data.amount : 0,
	  gamepass: this.data ? this.data.gamepass ?? "" : "",
	  email: this.data ? this.data.email : "",
	  promo: this.data ? this.data.promo : ""
	}
  },

  methods: {
	findByName() {
	  this.$root.setState({ label: "find-gamepass", data: { ...this.data, gamepass: this.gamepass, email: this.email, amount: this.amount, promo: this.promo } })
	},

  setMethod(method) {
    console.log(method)
    this.method = method
  },

	buy() { 
	  const match = Utils.parseGamepassID(this.gamepass)
	  if (!match) {
		return this.$root.toast.error("Неправильный формат ссылки")
	  }
	  const gid = parseInt(match[1]) 

	  this.$parent.startBuildingOrder({ method: this.method, gamepassesIds: [gid], email: this.email ?? undefined, amount: this.amount, promo: this.promo })
	}
  }
};
</script>

<style scoped lang="scss">
#buyList {
  width: 1022px;
}
</style>
